import type { AccessAction } from '../../domain/types/accessTypes';

type DecisionLabel = 'allow' | 'deny' | 'partial';

const TRACE_TTL_MS = 5000;
let pending: { action: AccessAction; rawAction: string; decision: DecisionLabel; createdAt: number } | null = null;

export function stageAccessDecisionTrace(action: AccessAction, rawAction: string, decision: DecisionLabel): void {
	pending = { action, rawAction: rawAction.slice(0, 200), decision, createdAt: Date.now() };
}

/** Consume once so unrelated background API calls cannot inherit stale context. */
export function takeAccessDecisionTraceHeaders(): Record<string, string> {
	const trace = pending;
	pending = null;
	if (!trace || Date.now() - trace.createdAt > TRACE_TTL_MS) return {};
	return {
		'x-deepmox-access-action': trace.action,
		'x-deepmox-access-raw': encodeURIComponent(trace.rawAction),
		'x-deepmox-client-decision': trace.decision,
	};
}

export function clearAccessDecisionTrace(): void {
	pending = null;
}
